<template>
  <section id="calendar-sheet__section--meta">
    <div
      id="calendar-sheet__date"
      class="text-white inline-block text-base font-normal tracking-[2px] mt-[1vh] py-[2px] px-[16px] uppercase"
    >
      {{ routedDate.toLocaleDateString("nl-NL", { weekday: "long" }) }},
      {{
        routedDate.toLocaleDateString("nl-NL", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      }}
    </div>

    <h1
      id="calendar-sheet__title"
      class="inline-block text-[29px] font-light tracking-[.412px] text-center"
      :key="routedDay.title"
    >
      {{ routedDay.title }}
    </h1>

    <h2
      id="calendar-sheet__theme"
      class="border border-solid rounded-[6px] inline-block text-[17px] font-light pt-[2px] px-[16px] pb-[4px] tracking-[.5px]"
      :key="routedDay.theme"
    >
      thema: {{ routedDay.theme }}
    </h2>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CalendarSheetMeta",
  computed: {
    ...mapGetters(["routedDay"]),

    routedDate() {
      if (!this.routedDay) {
        return null;
      }
      return new Date(this.routedDay.date);
    },
  },
};
</script>

<style lang="css">
.school-level-onderbouw #calendar-sheet__date {
  @apply bg-green;
}

.school-level-midden-bovenbouw #calendar-sheet__date {
  @apply bg-blue;
}

.school-level-onderbouw #calendar-sheet__theme {
  @apply text-green border-green;
}

.school-level-midden-bovenbouw #calendar-sheet__theme {
  @apply text-blue border-blue;
}
</style>
